require('./RASuitabilityTestSuccess.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ components
const HighLightedText = require('components/highLightedText/highLightedText');
// @ utilities
import { FormattedText } from 'core/i18n';
import { OtpBlock } from 'components/commons/OtpBlock/OtpBlock.jsx';
// @ actions
import UtagHelper from 'utilities/utagHelper';
import jointHoldersActions from 'actions/jointHoldersActions';
import RASuitabilityTest from 'actions/RASuitabilityTest';
import RAOtpActions from 'actions/RAOtpActions';
// @ constants
const { SUITABILITY_TEST_VALID } = require('constants/RAConstants/index');
const {
    EVENT_DETAIL_OTP_FIELD,
    EVENT_DETAIL_OTP_FAILURE,
    EVENT_DETAIL_OTP_SUCCESS,
    TEST_PROCESS_STEP_SUCCESS,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_OTP_NEW,
} = require('constants/uTagConstants/RAConstants');
const { PATH_ROBO_TI, PATH_GBI_TI } = require('constants/uTagConstants/paths');
const { ROBO } = require('constants/userProfile');

class RASuitabilityTestSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taggedOtpOk: false,
        };
    }

    componentDidMount() {
        const { RAOtpActions } = this.props;
        RAOtpActions.resetOTP();
    }

    componentDidUpdate() {
        const { immSuitabilityTest, immCheckStatus } = this.props;
        const { taggedOtpOk } = this.state;
        const otpchange = immSuitabilityTest.get('isValidOTP');
        if (
            !taggedOtpOk &&
            (otpchange || immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID) &&
            !immSuitabilityTest.get('isSigningTest') &&
            !immSuitabilityTest.get('signTestFailed') &&
            !immSuitabilityTest.get('wasOTPValidated')
        ) {
            this.recordEvent(EVENT_DETAIL_OTP_SUCCESS);
            this.setTaggedOtp(true);
        }
    }

    setTaggedOtp = valid => {
        this.setState({ taggedOtpOk: valid });
    };

    recordEvent = (eventDetail = '') => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_SUCCESS,
            eventDetail,
            userProfile
        );
    };

    onHandleReloadOtp = () => {
        const { userProfile, jointHoldersActions } = this.props;
        const accessToken = userProfile.accessToken;
        jointHoldersActions.getNewOtp(accessToken);
        this.recordEvent(EVENT_DETAIL_OTP_NEW);
    };

    onHandleValidateOTP = otpCode => {
        const { userProfile, raSuitabilityTest, RAOtpActions } = this.props;
        const { accessToken } = userProfile;
        const otpCodeU = otpCode ? otpCode.toUpperCase() : '';
        const payload = { otp: otpCodeU };
        RAOtpActions.postVerifyRoboOtp(payload, accessToken, raSuitabilityTest.signTest);
    };

    buildOtpView = () => {
        const { immSuitabilityTest, immCheckStatus } = this.props;
        const loadingOTP = immSuitabilityTest.get('loadingReloadOTPCode') || immSuitabilityTest.get('isSigningTest');
        const isValidOTP = immSuitabilityTest.get('isValidOTP');
        const otpSuccess =
            (isValidOTP || immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID) &&
            !immSuitabilityTest.get('isSigningTest') &&
            !immSuitabilityTest.get('signTestFailed');
        const wasOTPValidated = immSuitabilityTest.get('wasOTPValidated');
        return (
            <div className="joint-holder__wrapper-otp">
                <OtpBlock
                    autoValidate
                    otpModel={'userProfile.otpCode'}
                    className="joint-holder__otp"
                    validateOTP={this.onHandleValidateOTP}
                    reloadOtp={this.onHandleReloadOtp}
                    isValidOTP={isValidOTP}
                    loadingOTP={loadingOTP}
                    wasOTPValidated={wasOTPValidated}
                    otpSuccess={otpSuccess}
                    handleTaggingOnClick={this.recordEvent(EVENT_DETAIL_OTP_FIELD)}
                    handleTaggingBuildOtpInput={this.recordEvent(EVENT_DETAIL_OTP_FAILURE)}
                />
            </div>
        );
    };

    render() {
        const { disclaimer, firstParagraph, onConfirm, secondParagraph, profile, showOtpComponent } = this.props;
        return (
            <section className="ra-suitability-test-success">
                <div className="ra-suitability-test-success__top-disclaimer">{disclaimer}</div>
                <div className="ra-suitability-test-success__profile-section">
                    <div className="ra-suitability-test-success__icon-container">
                        <i className="ra-suitability-test-success__icon" />
                    </div>
                    <p className="ra-suitability-test-success__title">
                        <FormattedText value="raSuitabilityTestSuccess-title" />
                    </p>
                    <p className="ra-suitability-test-success__profile">{profile}</p>
                    <div className="ra-suitability-test-success__description">
                        <span className="ra-suitability-test-success__description-text">{firstParagraph}</span>
                    </div>
                    <div className="ra-suitability-test-success__disclaimer">
                        <span className="ra-suitability-test-success__disclaimer-text">{secondParagraph}</span>
                    </div>
                </div>
                <div className="ra-suitability-test-success__signature-pattern-title-section">
                    <div className="ra-suitability-test-success__signature-pattern-title">
                        <FormattedText value="raSuitabilityTestSuccess-otpTitle" />
                    </div>
                    <div className="ra-suitability-test-success__signature-pattern-description">
                        <FormattedText value="raSuitabilityTestSuccess-otpDescription" />
                    </div>
                </div>
                <div className="ra-suitability-test-success__signature-pattern-container">
                    {showOtpComponent ? (
                        this.buildOtpView()
                    ) : (
                        <div className="ra-suitability-test-success__button">
                            <button type="button" className="form__button form__button-secondary" onClick={onConfirm}>
                                <FormattedText value="raSuitabilityTestSuccess-signButtonLabel" />
                            </button>
                        </div>
                    )}
                </div>
                <div className="ra-suitability-test-success__notification">
                    <HighLightedText
                        className="form__hightlight-text form__hightlight-text--disclaimer"
                        icon={<i className="icons icons--icon-info-blue" />}
                    >
                        <FormattedText value={'raSuitabilityTestSuccess-notification'} />
                    </HighLightedText>
                </div>
            </section>
        );
    }
}
module.exports.constructor = RASuitabilityTestSuccess;
module.exports.RASuitabilityTestSuccess = connect(
    state => ({
        immCheckStatus: state.raCheckStatus,
        userProfile: state.userProfile,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    dispatch => ({
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
        RAOtpActions: bindActionCreators(RAOtpActions, dispatch),
    })
)(RASuitabilityTestSuccess);
